import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import {
  Text,
  Buttons,
  FlexContainer,
  useForm,
  Inputs,
  InputFormTypes,
} from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { updatePasswordAction } from 'Store/modules/auth/actions';
import useTranslation from 'Hooks/useTranslation';
import PasswordValidation from 'Components/PasswordValidation';
import { isValidPassword } from 'Utils/security';
import model from './model.json';

const initialState = {
  oldPassword: { value: '', isValid: false },
  newPassword: { value: '', isValid: false },
};

const UpdatePassword = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.ACCOUNT);
  const dispatch = useDispatch();
  const { formValues, isValidForm, onInputChange } = useForm(initialState);

  const onSubmit = (): void => {
    const values = {
      oldPassword: formValues.oldPassword.value,
      newPassword: formValues.newPassword.value,
    };
    dispatch(updatePasswordAction(values));
  };

  const isFormValid = useMemo(
    () => isValidPassword(formValues.newPassword.value) && isValidForm,
    [formValues]
  );

  return (
    <>
      <Text type="fds_heading_bold_H5" mb="fds_size_16" align="center">
        {t('UpdatePassword.title')}
      </Text>
      <FlexContainer direction="column" gap="dimension_08">
        <Inputs.InputForm
          inputForm={{
            ...model.oldPassword,
            label: t(model.oldPassword.label),
            type: InputFormTypes.PASSWORD,
          }}
          value={formValues.oldPassword.value?.toString()}
          onChange={(value, isValid) => onInputChange({ id: model.oldPassword.id, value, isValid })}
        />
        <Inputs.InputForm
          inputForm={{
            ...model.newPassword,
            label: t(model.newPassword.label),
            type: InputFormTypes.PASSWORD,
          }}
          value={formValues.newPassword.value?.toString()}
          onChange={(value, isValid) => onInputChange({ id: model.newPassword.id, value, isValid })}
        />
        <PasswordValidation password={formValues?.newPassword.value?.toString() ?? ''} isAccount />
        <Buttons.Classic
          mode="success"
          size="m"
          label={t('UpdatePassword.CTA')}
          fullWidth
          disabled={!isFormValid}
          onClick={onSubmit}
          testID="signInSubmit"
        />
      </FlexContainer>
    </>
  );
};

export default UpdatePassword;
